import Resource from './BaseResource'

class Contact extends Resource {
    constructor(config, tools, version, path) {
        super(config, tools, version, path)
    }
}

export default Contact